(function (angular) {
    'use strict';

    angular.module('shared')
        /**
         * 
         */
        .directive("formGroupSelect", ["$timeout", "utilService", function ($timeout, utilService) {
            // returns the Directive Definition Object
            return {
                require: '^form'/*, 'ngModel'*/,
                scope: {
                    model: "=",
                    name: "@",
                    label: "@",
                    required: "=",
                    values: "=",
                    showInvalid: "=",
                    itemLabel: "@",
                    itemValue: "@",
                    onChange: "&",
                    placeholder: "@",
                },
                templateUrl: "shared/directiveTemplates/form/directive.select.html",
                link: function (scope, element, attrs, form) {

                    scope.form = form;
                    // default to name
                    scope.label = scope.label || scope.name;

                    scope.hasError = function () {
                        return utilService.formFieldHasError(scope.showInvalid, scope.form, scope.name);
                    }

                    scope.changeCallback = function () {
                        if (scope.onChange) {
                            $timeout(function () {
                                scope.onChange();
                            });
                        }
                    }
                }
            };
        }]);
})(window.angular);
